<ng-container *transloco="let t">
  <div class="flex border-gray-100 bg-slate-50 px-3.5 py-1.5 text-slate-600">
    <div class="flex flex-[3_1_0%] items-center justify-center gap-2 truncate font-medium text-gray-800">
      {{ t("data-warehouse-resources.account_name") }}
    </div>
    <div class="flex flex-[3_1_0%] items-center justify-center gap-2 truncate font-medium text-gray-800">
      {{ t("data-warehouse-resources.marketplace") }}
    </div>
  </div>
  @for (accountMarketplace of accountMarketplaces; track accountMarketplace.accountId) {
    <div class="group flex gap-x-4 border-y px-3.5 py-3.5 text-sm tracking-tight transition-colors duration-100">
      <div class="flex flex-[3_1_0%] justify-center gap-2 truncate font-medium text-gray-800">
        {{ accountMarketplace.accountName }}
      </div>
      <div class="flex flex-[3_1_0%] justify-center gap-2 truncate font-medium text-gray-800">
        <IMarketplaceFlag [marketplace]="accountMarketplace.marketplace"></IMarketplaceFlag>
        {{ accountMarketplace.marketplace }}
      </div>
    </div>
  }
</ng-container>
